import GoogleLoginWrapper from './GoogleLoginWrapper';

export default GoogleLoginWrapper;
